import { Stack } from "@mui/material";

import { CardProps } from "./types";
import Layer from "../Layer";

const Card = ({ layers, openDialog, season }: CardProps) => {
  return (
    <Stack
      direction="column"
      // spacing="0.5rem"
      sx={{
        width: "100%",
      }}
    >
      {layers?.map((layer, index) => (
        <Stack key={layer.displayName}>
          <Layer {...layer} season={season} openDialog={openDialog} />
        </Stack>
      ))}
    </Stack>
  );
};

export default Card;
